import { createAction } from "@reduxjs/toolkit";

export const priceList = createAction<any>("prices/lists");
